export default "__VITE_ASSET__Dp0ZQRy3__"